import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import API_BASE_URL from '../config/api';
import { useLang } from '../context/LanguageContext';

const urlToPageId = {
  '/': 'home',
  '/about': 'about',
  '/contact': 'contact',
  '/blog': 'blog',
  '/services': 'services',
  '/specialization': 'specialization',
  '/industries': 'industries',
  '/products': 'products'
};

export const useSEO = (pageId) => {
  const location = useLocation();
  const { nl } = useLang();
  const [seoData, setSeoData] = useState(null);
  
  useEffect(() => {
    const currentPageId = pageId || urlToPageId[location.pathname] || 'home';
    
    fetch(`${API_BASE_URL}/api/seo/${currentPageId}`)
      .then(res => res.json())
      .then(data => {
        if (data.success && data.data) {
          setSeoData(data.data);
        }
      })
      .catch(err => console.error('SEO fetch error:', err));
  }, [pageId, location.pathname]);

  if (!seoData) return null;

  const title = (nl && seoData.title_nl) || seoData.title || 'Aurelia Technology';
  const description = (nl && seoData.description_nl) || seoData.description || '';
  const keywords = (nl && seoData.keywords_nl) || seoData.keywords || '';
  const ogTitle = (nl && seoData.ogTitle_nl) || seoData.ogTitle || title;
  const ogDescription = (nl && seoData.ogDescription_nl) || seoData.ogDescription || description;
  const ogImage = seoData.ogImage || '';
  const canonicalUrl = seoData.canonicalUrl || '';

  return (
    <Helmet>
      <title>{title}</title>
      {description && <meta name="description" content={description} />}
      {keywords && <meta name="keywords" content={keywords} />}
      {ogTitle && <meta property="og:title" content={ogTitle} />}
      {ogDescription && <meta property="og:description" content={ogDescription} />}
      {ogImage && <meta property="og:image" content={ogImage} />}
      {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}
    </Helmet>
  );
};
